import React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

const CameraIcon = (props: SvgProps) => {
  return (
    <Svg width="20" height="18" fill="none">
      <Path
        fill="#fff"
        d="M17.5 2.25h-2.599L13.623.334A.749.749 0 0 0 13 0H7a.75.75 0 0 0-.623.334L5.097 2.25H2.5A2.25 2.25 0 0 0 .25 4.5V15a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 19.75 15V4.5a2.25 2.25 0 0 0-2.25-2.25Zm-4.125 7.125a3.374 3.374 0 1 1-6.749 0 3.374 3.374 0 0 1 6.749 0Z"
      />
    </Svg>
  );
};

export default CameraIcon;
